import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import axios from 'axios';
import Header from '../components/Header'; 
import ExpirationAlert from '../components/ExpirationAlert';
import { useAuth } from '../hooks/useAuth';
import WhatsAppHelp from '../components/WhatsAppHelp';

const VITE_API_URL = import.meta.env.VITE_API_URL;

function DoctorLayout() {
    const { doctor, token } = useAuth(); 
    const [subscriptionData, setSubscriptionData] = useState(null);

    
    useEffect(() => {
        const fetchSubscriptionStatus = async () => {
            try {
                const response = await axios.get(`${VITE_API_URL}/doctors/me/full-profile`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (response.data) {
                    setSubscriptionData(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch subscription status", error);
            }
        };

        if (token) {
            fetchSubscriptionStatus();
        }
    }, [token]);

    
    const currentDoctorData = subscriptionData ? { ...doctor, ...subscriptionData } : doctor;

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col">
            <div className="z-50 relative">
                <Header /> 
            </div>
            
            
            <div className="z-40 relative">
                <ExpirationAlert doctor={currentDoctorData} />
            </div>

            <main className="pt-4 pb-10 flex-1">
                <Outlet />
            </main>
            <WhatsAppHelp doctorName={currentDoctorData?.name} />
        </div>
    );
}

export default DoctorLayout;